import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BRAND = 'The Cosmic Synthesist';

const ROUTE_TITLES = {
  '/': BRAND,
  '/work': `The Work \u2014 ${BRAND}`,
  '/foundations': `Foundations \u2014 ${BRAND}`,
  '/guidance': `Guidance \u2014 ${BRAND}`,
  '/instruments': `Instruments \u2014 ${BRAND}`,
  '/oracle-deck': `The Oracle Deck \u2014 ${BRAND}`,
  '/essays': `Essays \u2014 ${BRAND}`,
  '/about': `About \u2014 ${BRAND}`,
  '/contact': `Contact & Collaborate \u2014 ${BRAND}`,
  '/sacred-feminine-archetypes': `Sacred Feminine Archetypes \u2014 ${BRAND}`,
  '/sacred-feminine-quiz': `Archetype Quiz \u2014 ${BRAND}`,
  '/idea-clarity-session': `Idea Clarity Session \u2014 ${BRAND}`,
  '/planner': `Prism Planner \u2014 ${BRAND}`,
  '/admin': `Admin \u2014 ${BRAND}`,
  '/admin/login': `Admin Login \u2014 ${BRAND}`,
};

export const usePageTitle = (custom) => {
  const location = useLocation();

  useEffect(() => {
    if (custom) {
      document.title = `${custom} \u2014 ${BRAND}`;
      return;
    }

    // Check exact match first
    if (ROUTE_TITLES[location.pathname]) {
      document.title = ROUTE_TITLES[location.pathname];
      return;
    }

    // Check prefix matches
    if (location.pathname.startsWith('/work/')) {
      document.title = `Framework \u2014 ${BRAND}`;
    } else if (location.pathname.startsWith('/essays/')) {
      document.title = `Essay \u2014 ${BRAND}`;
    } else if (location.pathname.startsWith('/admin')) {
      document.title = `Admin \u2014 ${BRAND}`;
    } else {
      document.title = BRAND;
    }
  }, [location.pathname, custom]);
};
